<div id="overlay">
  <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
  <div
    style="position: absolute; width: 100%"
    [ngStyle]="{ height: contentHeight + 'px' }"
  >
    <app-fc21tutorials
      *ngIf="!isPortrait && data.game == 'fc21'"
      [language]="data.currentLanguage"
      [data]="data.gamedata"
      [tutorialPageCount]="tutorialCount"
      (tutorialsChange)="onCloseClick($event)"
    ></app-fc21tutorials>
    <app-fc21tutorialsmobile
      *ngIf="isPortrait && data.game == 'fc21'"
      [tutorialPageCount]="tutorialCount"
      [language]="data.currentLanguage"
      [data]="data.gamedata"
      (tutorialsChange)="onCloseClick($event)"
    ></app-fc21tutorialsmobile>
    <app-fcbtutorials
      *ngIf="!isPortrait && data.game == 'fcb'"
      [tutorialCount]="tutorialCount"
      [language]="data.currentLanguage"
      (modeClicked)="onCloseClick($event)"
    ></app-fcbtutorials>
    <app-fcbtutorialsmobile
      *ngIf="isPortrait && data.game == 'fcb'"
      [tutorialCount]="tutorialCount"
      [language]="data.currentLanguage"
      (modeClicked)="onCloseClick($event)"
    ></app-fcbtutorialsmobile>
  </div>
</div>
<!--
<div id="overlay">
  <table class="wrapper">
    <tr>
      <td>
          <div [ngClass]="'pop-up-container-'+data.game">
            <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
            <img [ngClass]="'img-bg-'+data.game"
                 src="./assets/images/help/{{data.game}}/{{data.currentLanguage}}/{{data.currentLanguage}}_{{data.tutorialContent['image_background']}}">
            <img [ngClass]="'img-content-'+data.game"
                 src="./assets/images/help/{{data.game}}/{{data.currentLanguage}}/{{data.currentLanguage}}_{{data.tutorialContent['image_'+tutorialCount]}}">
            <img *ngIf="!data.noClose" [ngClass]="'close-btn-'+data.game" src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp" (click)="onCloseClick($event)">
            <img [ngClass]="'home-btn-'+data.game" (click)="onHomeClick($event)" src="./assets/images/lobby_sprite_images/common/menu_sprite_images/tutorial_home.webp">
            <img [ngClass]="'right-btn-'+data.game" (click)="arrowClick('right')" src="./assets/images/lobby_sprite_images/common/menu_sprite_images/right.webp">
            <img [ngClass]="'left-btn-'+data.game" (click)="arrowClick('left')" src="./assets/images/lobby_sprite_images/common/menu_sprite_images/left.webp">
            <table *ngIf="tutorialCount === 0" [ngClass]="'menus-'+data.game">
              <tr  *ngFor="let menu of menuArr; let i=index">
                <td [ngClass]="'menu-'+data.game" (click)="(data.currentLanguage != 'he')?menuClick(i+1):menuClick(i+10)"><div></div></td>
                <td [ngClass]="'menu-'+data.game" (click)="(data.currentLanguage != 'he')?menuClick(i+10):menuClick(i+1)"><div></div></td>
              </tr>

            </table>
            <div class="quick-keys-content"
                 *ngIf="(data.game == 'fc21' && this.tutorialCount == 21)">
              <div class="quick-keys-header key-uppercase" [ngClass]="'quick-keys-header-'+data.currentLanguage">{{mapKeyConstant[data.currentLanguage]['0']}}</div>

              <div [ngClass]="'menu-left-'+data.currentLanguage">
              <div class="left-3 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['1']}}</div>
              <div class="left-4 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['2']}}</div>
              <div class="left-5 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['3']}}</div>
              <div class="left-6 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['4']}}</div>
              <div class="left-7 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['5']}}</div>
              <div class="left-8 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['6']}}</div>
              <div class="left-9 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['7']}}</div>
              <div class="left-10 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['8']}}</div>
              <div class="left-11 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['9']}}</div>
              <div class="left-12 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['0']}}</div>
              <div class="left-13 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['h']}}</div>
              <div class="left-14 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['i']}}</div>
              </div>
              <div [ngClass]="'menu-right-'+data.currentLanguage">
              <div class="right-1 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['s']}}</div>
              <div class="right-2 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['d']}}</div>
              <div class="right-3 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['r']}}</div>
              <div class="right-4 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['c']}}</div>
              <div class="right-5 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['y']}}</div>
              <div class="right-6 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['n']}}</div>
              <div class="right-7 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['x']}}</div>
              <div [ngClass]="'right-8-'+data.currentLanguage" class="right-8 quick-keys-text center_align">{{'LANG00952' | translate }}</div>
              <div [ngClass]="'right-9-'+data.currentLanguage" class="right-9 quick-keys-text center_align">{{'LANG00739' | translate }}</div>
              <div [ngClass]="'right-10-'+data.currentLanguage" class="right-10 quick-keys-text center_align">{{'LANG00739' | translate }}</div>
              <div [ngClass]="'right-11-'+data.currentLanguage" class="right-11 quick-keys-text center_align">{{'LANG00739' | translate }}</div>
              <div [ngClass]="'right-12-'+data.currentLanguage" class="right-12 quick-keys-text center_align">{{'LANG00739' | translate }}</div>
              <div class="right-13 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['e']}}</div>
              <div class="right-14 quick-keys-text key-uppercase center_align">{{mapKeyConstant[data.currentLanguage]['g']}}</div>
              </div>
            </div>
            &lt;!&ndash;below code are for showing payoff details&ndash;&gt;
            <div [ngStyle]="{'visibility':(pays_blank_tutorial['TN_pays_blank_position_'+(tutorialCount)].length > 0  && data.game == 'fc21' )?'visible':'hidden'}"
                 *ngFor="let pays_blank_position of  pays_blank_tutorial['TN_pays_blank_position_'+(tutorialCount)] ">
              <img [ngStyle]="{ 'width':(pays_blank_position.width ), 'height':(pays_blank_position.height ),'left':(pays_blank_position.left ), 'top':(pays_blank_position.top ),'position': 'absolute'}"
                   class=" button translate-top-most" src="assets/images/help/common/pays_blank_small@2x.webp"/>
              <div [ngStyle]="{ 'width':(pays_blank_position.width ), 'height':(pays_blank_position.height ),'left':(pays_blank_position.left ), 'top':(pays_blank_position.top ),'position': 'absolute'}">
                <span [ngStyle]="{  'font-family': loadingFontObj[data.currentLanguage].fontFamily , 'font-size': (loadingFontObj[data.currentLanguage].paysContentFontSize)+'vw'}" class="pays-content">{{pays_blank_position.paysContent|translate}}</span>
                <span [ngStyle]="{ 'font-family': loadingFontObj[data.currentLanguage].fontFamily , 'font-size': (loadingFontObj[data.currentLanguage].percentageContentFontSize)+'vw'}"  class="pays-percentage-content">{{pays_blank_position.percentageContent}}</span>
              </div>
           </div>


          </div>
      </td>
    </tr>
  </table>
</div>
-->
